import React from 'react';
import './Styles/App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet'; // for hiding the page from google search
import { AuthProvider } from './Components/AuthContext';

import Home from './Pages/Home';
import Login from './Pages/Login';
import ViewOfHCWs from './Pages/ViewOfHCWs';
import ViewOfGMFAccounts from './Pages/ViewOfGMFAccounts';
import ResetForgottenPassword from './Pages/ResetForgottenPassword';
import CreateAccount from './Pages/CreateAccount';
import EditAccount from './Pages/EditAccount';
import ChatOverview from './Pages/ChatOverview';
import ProtectedRoute from './Components/ProtectedRoute';
import AutoLogoutWrapper from './Components/AutoLogoutWrapper';
import ApproveRequests from './Pages/ApproveRequests';
import AppInstall from './Pages/AppInstall';
import AboutTeam from './Pages/AboutTeam';
import Layout from './Components/Layout';
import HcwAIChatHistory from './Pages/HcwAIChatHistory';
import ViewOfInstitutions from './Pages/ViewOfInstitutions';

function App() {
    return (
        <div className="App">
            <Router>
                <AuthProvider>
                    <Routes>
                        <Route element={<Layout />}>
                            {/* Public routes */}
                            <Route path="/" element={<Home />} />
                            <Route
                                path="/app"
                                element={
                                    <>
                                        <Helmet>
                                            <meta name="robots" content="noindex" />
                                        </Helmet>
                                        <AppInstall />
                                    </>
                                }
                            />
                            <Route
                                path="/about-team"
                                element={
                                    <AboutTeam />
                                }
                            />
                            <Route exact path="/login" element={<Login />} />
                            {/* for resetting a password if you forgot it */}
                            <Route
                                path="/forgot-password"
                                element={<ResetForgottenPassword />}
                            />
                            <Route
                                path="/create-account"
                                element={<CreateAccount />}
                            />

                            {/* The routes below require an authenticated token/user */}
                            <Route
                                path="/view-healthcare-workers"
                                element={
                                    <ProtectedRoute>
                                        <AutoLogoutWrapper>
                                            <ViewOfHCWs />
                                        </AutoLogoutWrapper>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/view-gmf-accounts"
                                element={
                                    <ProtectedRoute>
                                        <AutoLogoutWrapper>
                                            <ViewOfGMFAccounts />
                                        </AutoLogoutWrapper>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/chat"
                                element={
                                    <ProtectedRoute>
                                        <AutoLogoutWrapper>
                                            <ChatOverview />
                                        </AutoLogoutWrapper>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/approve-requests"
                                element={
                                    <ProtectedRoute>
                                        <AutoLogoutWrapper>
                                            <ApproveRequests />
                                        </AutoLogoutWrapper>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/hcw-ai-chats"
                                element={
                                    <ProtectedRoute>
                                        <AutoLogoutWrapper>
                                            <HcwAIChatHistory />
                                        </AutoLogoutWrapper>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/edit-account"
                                element={
                                    <ProtectedRoute>
                                        <AutoLogoutWrapper>
                                            <EditAccount />
                                        </AutoLogoutWrapper>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/view-institutions"
                                element={
                                    <ProtectedRoute>
                                        <AutoLogoutWrapper>
                                            <ViewOfInstitutions />
                                        </AutoLogoutWrapper>
                                    </ProtectedRoute>
                                }
                            />
                        </Route>
                    </Routes>
                </AuthProvider>
            </Router>
        </div>
    );
}

export default App;
